/* ============================================================
   Weidewild Bundle-Selector — JavaScript-Helpers
   1. Default-Selection-Forcer (gegen Mobile-Race-Condition)
   2. Single-Option-Marker: Selects mit nur 1 Option bekommen
      .wbw-single-option Klasse → CSS rendert sie als Info-Pill
   ============================================================ */
(function() {
  'use strict';

  // Slots mit variablen Gewichts-Stufen — bleiben immer als Dropdown,
  // auch wenn aktuell nur 1 Option (TK-Stufen kommen mit Bestand-Update dazu)
  var VARIABLE_SLOT_REGEX = /r(ü|u)cken|braten|filet|keule|sch(ä|a)uferla|haxe/i;

  function isVariableSlot(sel) {
    // Label finden via for=id oder previous sibling
    var label = null;
    if (sel.id) {
      label = document.querySelector('label[for="' + sel.id + '"]');
    }
    if (!label) {
      // Klettere im Parent hoch und suche label
      var parent = sel.parentElement;
      while (parent && parent.tagName !== 'BODY') {
        var lbl = parent.querySelector('label');
        if (lbl) { label = lbl; break; }
        parent = parent.parentElement;
      }
    }
    if (!label) {
      // Fallback: prevElementSibling
      label = sel.previousElementSibling;
    }
    if (!label) return false;

    var text = (label.textContent || '').trim();
    return VARIABLE_SLOT_REGEX.test(text);
  }

  function processBundleSelectors() {
    var containers = document.querySelectorAll('[data-simple-bundles-options]');
    if (!containers.length) return false;

    var didChange = false;

    containers.forEach(function(container) {
      var selects = container.querySelectorAll('select');
      selects.forEach(function(sel) {
        // 1) Default-Selection sicherstellen
        var current = sel.options[sel.selectedIndex];
        if (!current || current.disabled || !current.value) {
          for (var i = 0; i < sel.options.length; i++) {
            var opt = sel.options[i];
            if (!opt.disabled && opt.value) {
              sel.selectedIndex = i;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              didChange = true;
              break;
            }
          }
        }

        // 2) Single-Option-Marker — NUR fuer fixe Slots
        // Variable Slots (Ruecken/Braten/Filet/Keule/Schaeuferla/Haxe) bleiben Dropdown
        // auch wenn aktuell nur 1 Option (TK-Stufen kommen spaeter dazu).
        var variable = isVariableSlot(sel);
        var validOptionCount = 0;
        for (var j = 0; j < sel.options.length; j++) {
          if (!sel.options[j].disabled && sel.options[j].value) validOptionCount++;
        }

        if (!variable && validOptionCount <= 1) {
          if (!sel.classList.contains('wbw-single-option')) {
            sel.classList.add('wbw-single-option');
          }
        } else {
          if (sel.classList.contains('wbw-single-option')) {
            sel.classList.remove('wbw-single-option');
          }
        }
      });
    });

    return didChange;
  }

  // Backwards-compat name
  function ensureDefaultSelection() { return processBundleSelectors(); }

  // Initial-Versuch beim DOM-Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryEnsure);
  } else {
    tryEnsure();
  }

  function tryEnsure() {
    // Sofort versuchen
    ensureDefaultSelection();

    // Plus mehrere Folge-Versuche, da App async rendert
    var attempts = 0;
    var maxAttempts = 20;
    var interval = setInterval(function() {
      attempts++;
      ensureDefaultSelection();
      if (attempts >= maxAttempts) clearInterval(interval);
    }, 250);

    // Mutation Observer für späteren App-Render
    if (window.MutationObserver) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.addedNodes.length > 0) {
            ensureDefaultSelection();
          }
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });

      // Nach 10s Observer trennen (Performance)
      setTimeout(function() { observer.disconnect(); }, 10000);
    }
  }
})();
